import React from "react";

/* 
  type keywords = {
    keywords: {
      {
        string: string;
      }[]
    },
    target: {
      url: string;
    }
  }[]

    =>
  
  type keywordTargetPairs = {
    target: string;
    keyword: string;
  }[]
*/
export function transformKeywords(keywords) {
  return keywords
    ?.map(({ target, keywords }) =>
      keywords.map((keyword) => ({
        target: target?.url,
        keyword: keyword?.string,
      }))
    )
    .flat()
    .filter((pair) => pair?.target && pair.keyword?.length)
    .sort((pairA, pairB) => pairB.keyword.length - pairA.keyword.length);
}

export function replaceKeywords(
  input,
  keywordTargetPairs,
  linkClassName = undefined
) {
  if (typeof input === "string") {
    const replacableLocations = getReplacableLocations(
      input,
      keywordTargetPairs
    );
    return insertElement(input, replacableLocations, linkClassName);
  } else {
    try {
      return input
        ?.map((element) => {
          if (typeof element !== "string") {
            return element;
          }
          const replacableLocations = getReplacableLocations(
            element,
            keywordTargetPairs
          );
          return insertElement(element, replacableLocations, linkClassName);
        })
        .flat();
    } catch {
      return input;
    }
  }
}

function getReplacableLocations(text, keywordTargetPairs) {
  const replacableLocations = [];
  for (const { target, keyword } of keywordTargetPairs || []) {
    const keywordMatches = [
      ...(text
        ?.toLowerCase()
        .matchAll(
          `(^|[ "\\(\\)])([^ ;:'"\\(\\)]*${keyword.toLowerCase()}[^ ;:'"\\(\\)]*)([ :\\.,"\\(\\)]|$)`
        ) || []),
    ];

    keywordMatches?.forEach((match) => {
      const start = match.index + match[1].length;
      const end = start + match[2].length;

      if (
        replacableLocations.some(
          (location) =>
            (start <= location.start && location.start < end) ||
            (start < location.end && location.end <= end)
        )
      ) {
        return;
      }

      const replacableLocation = {
        start,
        end,
        keyword,
        target,
        replacable: text.substring(start, end),
      };
      replacableLocations.push(replacableLocation);
    });
  }
  return replacableLocations.sort(
    (locationA, locationB) => locationA.start - locationB.start
  );
}

function insertElement(input, replacableLocations, linkClassName) {
  const elements = [];
  let currentLocation = 0;
  for (const replacableLocation of replacableLocations || []) {
    elements.push(
      String(input).substring(currentLocation, replacableLocation.start)
    );
    elements.push(
      <a
        key={`element-${elements.length - 1}`}
        href={replacableLocation.target}
        className={
          linkClassName ??
          "text-link-color underline visited:text-link-visited hover:text-link-hover"
        }
        style={{
          fontWeight: "inherit",
        }}
      >
        {replacableLocation.replacable}
      </a>
    );
    currentLocation = replacableLocation.end;
  }
  elements.push(String(input).substring(currentLocation));

  return elements;
}
